/* ELBE1 Teilesuche nach Motor/Antrieb + Funktionsgruppe.
   Index: fitment-index.json (build_fitment_index.py)
     h  = [handle]                      Produkte
     m  = [[Modell, Anzahl]]            mp = Produktliste je Modell
     g  = [[Gruppen-Key, Anzahl]]       gp = Produktliste je Gruppe
   Produktlisten: aufsteigende Indizes, Delta-Base36, '.'-getrennt.
   Texte kommen aus window.elbe1Fit (serverseitig per `| t` gerendert). */
(function () {
  'use strict';
  var C = window.elbe1Fit;
  if (!C) return;
  // `| t` liefert HTML-escapte Texte (z. B. '&amp;') -> einmal dekodieren, beim Einfügen wird wieder escaped
  var dec = document.createElement('textarea');
  [C.t, C.groups].forEach(function (o) { Object.keys(o).forEach(function (k) { dec.innerHTML = o[k]; o[k] = dec.value; }); });
  var T = C.t, ROOT = C.root === '/' ? '/' : C.root.replace(/\/?$/, '/');
  var PAGE = 24, LIST_MAX = 80, LS_KEY = 'elbe1_fit_model';

  // ---------- Index laden (einmal, lazy) ----------
  var idxPromise = null, IDX = null;
  function loadIndex() {
    if (!idxPromise) {
      idxPromise = fetch(C.indexUrl, { cache: 'force-cache' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          d.mn = d.m.map(function (m) { return norm(m[0]); });
          d.mpCache = {}; d.gpCache = {};
          IDX = d; return d;
        });
    }
    return idxPromise;
  }
  function decode(s) {
    var out = [], prev = 0;
    if (!s) return out;
    s.split('.').forEach(function (t) { prev += parseInt(t, 36); out.push(prev); });
    return out;
  }
  function modelProducts(i) { return IDX.mpCache[i] || (IDX.mpCache[i] = decode(IDX.mp[i])); }
  function groupProducts(i) { return IDX.gpCache[i] || (IDX.gpCache[i] = decode(IDX.gp[i])); }
  function groupIndex(key) { for (var i = 0; i < IDX.g.length; i++) if (IDX.g[i][0] === key) return i; return -1; }

  function norm(s) { return String(s || '').toUpperCase().replace(/[^0-9A-Z]/g, ''); }

  // Modell-Eingabe -> Modell-Indizes: exakter Treffer, sonst alle Modelle mit diesem Anfang (z. B. AQ271 -> A–D)
  function resolveModels(q) {
    var k = norm(q); if (!k) return [];
    for (var i = 0; i < IDX.mn.length; i++) if (IDX.mn[i] === k) return [i];
    var out = [];
    for (var j = 0; j < IDX.mn.length; j++) if (IDX.mn[j].indexOf(k) === 0) out.push(j);
    return out;
  }
  function union(lists) {
    if (lists.length === 1) return lists[0];
    var seen = {}, out = [];
    lists.forEach(function (l) { l.forEach(function (x) { if (!seen[x]) { seen[x] = 1; out.push(x); } }); });
    return out.sort(function (a, b) { return a - b; });
  }
  function intersect(a, b) {
    var set = {}, out = [];
    b.forEach(function (x) { set[x] = 1; });
    a.forEach(function (x) { if (set[x]) out.push(x); });
    return out;
  }
  function productsFor(modelQ, groupKey) {
    var base = null;
    if (modelQ) {
      var mi = resolveModels(modelQ);
      base = union(mi.map(modelProducts));
    }
    if (groupKey) {
      var gi = groupIndex(groupKey);
      var gl = gi < 0 ? [] : groupProducts(gi);
      base = base ? intersect(base, gl) : gl;
    }
    return base || [];
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---------- Header-Formular ----------
  function initForm() {
    var form = document.getElementById('Elbe1FitForm');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var input = form.querySelector('.elbe1-fit__model');
    var list = form.querySelector('.elbe1-fit__list');
    var clear = form.querySelector('.elbe1-fit__clear');
    var select = form.querySelector('.elbe1-fit__group');
    var active = -1, items = [];

    // Vorbelegung: URL, sonst zuletzt gewähltes Modell
    var p = new URLSearchParams(location.search);
    var pm = p.get('modell'), pg = p.get('gruppe');
    var stored = null;
    try { stored = localStorage.getItem(LS_KEY); } catch (e) {}
    input.value = pm || stored || '';
    if (pg) select.value = pg;
    clear.hidden = !input.value;
    if (input.value || pg) loadIndex().then(updateGroupCounts);

    ['focusin', 'pointerenter', 'touchstart'].forEach(function (ev) {
      form.addEventListener(ev, function () { loadIndex(); }, { once: true, passive: true });
    });

    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function render() {
      var k = norm(input.value), pref = [], cont = [];
      for (var i = 0; i < IDX.mn.length; i++) {
        var n = IDX.mn[i];
        if (!k || n.indexOf(k) === 0) pref.push(i);
        else if (k.length >= 2 && n.indexOf(k) > 0) cont.push(i);
        if (pref.length >= LIST_MAX) break;
      }
      items = pref.concat(cont).slice(0, LIST_MAX);
      if (!items.length) {
        list.innerHTML = '<li class="elbe1-fit__empty">' + esc(T.noMatch) + '</li>';
      } else {
        list.innerHTML = items.map(function (i, pos) {
          return '<li role="option" id="Elbe1FitOpt' + pos + '" data-i="' + i + '" class="elbe1-fit__opt">'
            + '<span>' + esc(IDX.m[i][0]) + '</span><span class="elbe1-fit__count">' + IDX.m[i][1] + ' ' + esc(T.parts) + '</span></li>';
        }).join('');
      }
      active = -1;
      list.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    function highlight(pos) {
      var opts = list.querySelectorAll('.elbe1-fit__opt');
      if (!opts.length) return;
      active = (pos + opts.length) % opts.length;
      opts.forEach(function (o, j) { o.classList.toggle('is-active', j === active); });
      opts[active].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', opts[active].id);
    }
    function choose(i) {
      input.value = IDX.m[i][0];
      clear.hidden = false;
      close();
      updateGroupCounts();
      select.focus();
    }

    input.addEventListener('focus', function () { loadIndex().then(render); });
    input.addEventListener('input', function () {
      clear.hidden = !input.value;
      loadIndex().then(function () { render(); updateGroupCounts(); });
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) render(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter' && !list.hidden && active >= 0) { e.preventDefault(); choose(items[active]); }
      else if (e.key === 'Escape') { close(); }
    });
    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.elbe1-fit__opt');
      if (li) { e.preventDefault(); choose(+li.dataset.i); }
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
    clear.addEventListener('click', function () {
      input.value = ''; clear.hidden = true;
      try { localStorage.removeItem(LS_KEY); } catch (e) {}
      updateGroupCounts(); input.focus();
    });

    // Anzahl je Funktionsgruppe für das gewählte Modell, leere Gruppen deaktivieren
    function updateGroupCounts() {
      if (!IDX) return;
      var base = input.value ? union(resolveModels(input.value).map(modelProducts)) : null;
      Array.prototype.forEach.call(select.options, function (o) {
        if (!o.dataset.label) o.dataset.label = o.textContent;
        if (!o.value) return;
        var gi = groupIndex(o.value);
        var n = gi < 0 ? 0 : (base ? intersect(base, groupProducts(gi)).length : IDX.g[gi][1]);
        o.textContent = o.dataset.label + ' (' + n + ')';
        o.disabled = n === 0 && o.value !== select.value;
      });
    }

    form.addEventListener('submit', function (e) {
      var m = input.value.trim(), g = select.value;
      if (!m && !g) { e.preventDefault(); input.focus(); return; }
      try { if (m) localStorage.setItem(LS_KEY, m); } catch (er) {}
      // leere Parameter nicht mitschicken
      if (!m) input.disabled = true;
      if (!g) select.disabled = true;
      setTimeout(function () { input.disabled = false; select.disabled = false; }, 0);
    });
  }

  // ---------- Ergebnisseite (/collections/all?modell=…&gruppe=…) ----------
  function initResults() {
    var box = document.getElementById('elbe1-fit');
    if (!box) return;
    var p = new URLSearchParams(location.search);
    if (p.get('oem') || !(p.get('modell') || p.get('gruppe'))) return;
    var state = { m: (p.get('modell') || '').trim(), g: p.get('gruppe') || '' };
    var head = box.querySelector('.elbe1-fit-head');
    var chips = box.querySelector('.elbe1-fit-chips');
    var grid = box.querySelector('.elbe1-fit-grid');
    var more = box.querySelector('.elbe1-fit-more');
    var empty = box.querySelector('.elbe1-fit-empty');
    var shown = 0, current = [], token = 0;

    more.textContent = T.loadMore;
    more.addEventListener('click', function () { showNext(); });

    loadIndex().then(function () { draw(); });

    function label() {
      var parts = [];
      if (state.m) {
        var mi = resolveModels(state.m);
        parts.push(mi.length === 1 ? IDX.m[mi[0]][0] : state.m.toUpperCase() + (mi.length > 1 ? ' (' + mi.length + ' ' + T.variants + ')' : ''));
      }
      return parts.join('');
    }
    function draw() {
      current = productsFor(state.m, state.g);
      var title;
      if (state.m) title = current.length + ' ' + T.resultsFor + ' ' + label();
      else title = current.length + ' ' + T.resultsIn;
      if (state.g) title += (state.m ? ' · ' : ' ') + (C.groups[state.g] || state.g);
      head.innerHTML = '<h2 class="title title--primary">' + esc(title) + '</h2>';

      // Gruppen-Chips (nur mit Modell sinnvoll): Anzahl je Gruppe
      if (state.m) {
        var base = productsFor(state.m, '');
        var html = '<button type="button" class="elbe1-fit-chip' + (state.g ? '' : ' is-active') + '" data-g="">' + esc(T.chipAll) + ' (' + base.length + ')</button>';
        IDX.g.forEach(function (g, gi) {
          var n = intersect(base, groupProducts(gi)).length;
          if (!n) return;
          html += '<button type="button" class="elbe1-fit-chip' + (state.g === g[0] ? ' is-active' : '') + '" data-g="' + g[0] + '">'
            + esc(C.groups[g[0]] || g[0]) + ' (' + n + ')</button>';
        });
        chips.innerHTML = html; chips.hidden = false;
      } else {
        chips.hidden = true;
      }

      grid.innerHTML = ''; shown = 0; token++;
      empty.hidden = current.length > 0;
      if (!current.length) attachRequestForm();
      showNext();
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.elbe1-fit-chip');
      if (!b) return;
      state.g = b.dataset.g;
      var q = new URLSearchParams(location.search);
      if (state.g) q.set('gruppe', state.g); else q.delete('gruppe');
      history.replaceState(null, '', location.pathname + '?' + q.toString());
      var sel = document.getElementById('Elbe1FitGroup');
      if (sel) sel.value = state.g;
      draw();
    });

    function showNext() {
      var my = token;
      var slice = current.slice(shown, shown + PAGE);
      shown += slice.length;
      more.hidden = shown >= current.length;
      // Platzhalter in fester Reihenfolge, dann parallel füllen
      var slots = slice.map(function () {
        var li = document.createElement('li'); li.className = 'grid__item elbe1-fit-slot'; grid.appendChild(li); return li;
      });
      slice.forEach(function (pi, k) {
        fetch(ROOT + 'products/' + IDX.h[pi] + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (pr) {
            if (my !== token) return;
            if (!pr) { slots[k].remove(); return; }
            slots[k].classList.remove('elbe1-fit-slot');
            slots[k].innerHTML = card(pr);
          })
          .catch(function () { slots[k].remove(); });
      });
    }
    function eur(c) { try { return (c / 100).toLocaleString(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }); } catch (e) { return (c / 100) + ' €'; } }
    function card(pr) {
      var src = pr.featured_image ? (pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500') : '';
      return '<div class="card-wrapper product-card-wrapper underline-links-hover">'
        + '<a class="elbe1-card-link" href="' + ROOT + 'products/' + pr.handle + '">'
        + (src ? '<div class="elbe1-card-media"><img src="' + src + '" alt="" loading="lazy"></div>' : '<div class="elbe1-card-media"></div>')
        + '<div class="card__content"><div class="card__information">'
        + '<h3 class="card__heading h5"><span class="full-unstyled-link">' + esc(pr.title) + '</span></h3>'
        + '<div class="card-information">'
        + '<span class="caption-large light">' + esc(pr.vendor || '') + '</span>'
        + '<div class="price"><span class="price-item price-item--regular">' + eur(pr.price) + '</span>'
        + (pr.available ? '' : ' <span class="caption light">· ' + esc(T.soldOut) + '</span>') + '</div>'
        + '</div></div></div></a></div>';
    }
    // Anfrage-Formular der OEM-Suche wiederverwenden (gibt es nur einmal pro Seite)
    function attachRequestForm() {
      var f = document.querySelector('#elbe1-oem-empty .elbe1-anfrage');
      var slot = empty.querySelector('.elbe1-fit-request');
      if (f && slot && !slot.contains(f)) slot.appendChild(f);
    }
  }

  function init() { initForm(); initResults(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
